// the enum should have the same name as the package.
export enum WIDGET_EVENT_METADATA {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=109926272
     */
    ADD_TO_MY_CALENDAR = 'WIDGET_EVENT_METADATA.ADD_TO_MY_CALENDAR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=109930867
     */
    GOOGLE_CALENDAR = 'WIDGET_EVENT_METADATA.GOOGLE_CALENDAR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=136811663
     */
    ICALENDAR = 'WIDGET_EVENT_METADATA.ICALENDAR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=109930873
     */
    OUTLOOK = 'WIDGET_EVENT_METADATA.OUTLOOK',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=101618463
     */
    ATTENDEES_NUMBER = 'FRONT.WIDGET_EVENT_METADATA.ATTENDEES_NUMBER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=101618687
     */
    DATE_TIME = 'FRONT.WIDGET_EVENT_METADATA.DATE_TIME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=101619238
     */
    LOCATION = 'FRONT.WIDGET_EVENT_METADATA.LOCATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=101619245
     */
    LINK = 'FRONT.WIDGET_EVENT_METADATA.LINK',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=102121716
     */
    REGISTER = 'FRONT.EVENT_BUTTON.REGISTER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=102155190
     */
    REGISTERED = 'FRONT.EVENT_BUTTON.REGISTERED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=103174766
     */
    DATE_TIME_VALUE = 'FRONT.WIDGET_EVENT_METADATA.DATE_TIME.VALUE',
}
